















































































import { defineComponent, onMounted, ref } from "@vue/composition-api"
import {
  useFindOneBooking,
  useCancelBooking,
  useStartBooking,
} from "@/app/reactive/booking"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import BookingGateControls from "./BookingGateControls.vue"
import { FacilityModel } from "@/app/models/facility.model"
import BookingDetailInfoBox from "@/app/components/booking/BookingDetailInfoBox.vue"
import ReservationTime from "@/app/components/booking/ReservationTime.vue"
import { useIoTControl } from "@/app/reactive/iot-control/iot-control.reactive"

export default defineComponent({
  name: "BookingReserved",
  components: {
    Subtitle,
    Content,
    Hint,
    BookingGateControls,
    BookingDetailInfoBox,
    ReservationTime,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup(props: { reservedAt: Date }) {
    const { cancelBooking } = useCancelBooking()
    const { startBooking } = useStartBooking()
    const { booking } = useFindOneBooking()
    const { openMainGate, fetchGatesWithSpamPrevention } = useIoTControl()

    const isConfirmDialogOpen = ref(false)
    const timeString = ref<string>("")

    const maxTimeInMinutes = 120

    const closeDialog = () => (isConfirmDialogOpen.value = false)
    const openDialog = () => (isConfirmDialogOpen.value = true)

    function calcNewTimeString(reservedAt: Date) {
      if (reservedAt) {
        const diffMs = Date.now() - reservedAt.getTime()
        const diffMins = Math.round(
          ((diffMs % 86400000) % (maxTimeInMinutes * 60000)) / 60000,
        )
        const countdownInMins = maxTimeInMinutes - diffMins
        timeString.value = `${countdownInMins > 0 ? countdownInMins : 0} Min`
      } else {
        timeString.value = ""
      }
    }

    onMounted(() => {
      calcNewTimeString(props.reservedAt)
    })

    async function cancel() {
      await cancelBooking(booking)
      closeDialog()
    }

    async function startBookingAction() {
      await startBooking(booking)

      // Fetch gates
      await fetchGatesWithSpamPrevention(booking.value.facilityId)

      // Open the gate
      await openMainGate(booking.value.id)
    }

    return {
      booking,
      openDialog,
      closeDialog,
      cancel,
      startBookingAction,
      isConfirmDialogOpen,
    }
  },
})
